// import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { notification } from 'antd';
//Component
import { LOAD_PAPERWORK_LIST } from '../type';
import {
  //List
  loadPaperworkListSuccessAction,
  loadPaperworkListErrorAction,
} from '../action';

import { paperworkService } from 'services';

function* loadPaperworkList() {
  while (1) {
    const action = yield take(LOAD_PAPERWORK_LIST);
    try {
      const listPackage = yield call(
        paperworkService.loadPaperworkList,
        action.payload,
      );
      yield put(loadPaperworkListSuccessAction(listPackage));
    } catch (err) {
      yield put(loadPaperworkListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([loadPaperworkList()]);
}
